<template>
    <div class="ma-4">
        <v-snackbar
          v-model="msg"
          top
          :color="snackbarColor"
          :timeout="3000"
          elevation="4"
          class="rounded-lg"
        >
          <div class="d-flex align-center">
            <v-icon class="mr-2">{{
              snackbarColor === "success" ? "mdi-check-circle" : "mdi-alert"
            }}</v-icon>
            {{ text }}
          </div>
          <template v-slot:action="{ attrs }">
            <v-btn icon small v-bind="attrs" @click="msg = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-card class="rounded-lg">
          <v-app-bar flat dense color="grey lighten-4" class="rounded-t-lg px-3">
            <v-btn icon small class="mr-2 grey lighten-3" @click="$router.go(-1)">
              <v-icon>navigate_before</v-icon>
            </v-btn>

            <span class="text-h6 font-weight-medium grey--text text--darken-3">
              Locations
            </span>

            <v-spacer></v-spacer>
          </v-app-bar>

          <v-divider></v-divider>

          <!-- Data Table -->
          <v-card-text class="pa-6">
            <v-data-table
              :headers="headers"
              :items="units"
              sort-by="Name"
              sort-asc
              class="elevation-1 rounded-lg"
              :loading="isLoading"
              loading-text="Loading Locations"
              :footer-props="{
                'items-per-page-options': [5, 10, 20, 50],
                showFirstLastPage: true,
                'items-per-page-text': 'Rows per page:',
                class: 'rounded-lg',
              }"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
    </div>
</template>
<script>
import axios from 'axios'
// import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

  export default {
    components: {
    },
    data: () => ({
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'Name',
      },
      { text: "Address", value: "Address" },
      { text: "City", value: "City" },
      { text: "State", value: "State" },
      { text: "Zip", value: "Zip" },
    ],
    units: [],
    isLoading: false,
    requiredField: [
        v => !!v || 'This is required',
    ],
    userState: localStorage.getItem('userState'),
    msg: false,
    text: "",
    snackbarColor: "success",
    }),

    computed: {
      
    },

    created() {
      this.getUnits();
      
    },

    methods: {
      initialize() {
        this.units = [];
      },
      
      getUnits() {
          this.units = []
          this.isLoading = true

          const companyIds = localStorage.getItem('userCompanies');

          axios.get(`${url}/units/state/${this.userState}`, {
            params: {
              Company: JSON.parse(companyIds)
            }
          }).then(res => {
            this.units = res.data.units
            this.isLoading = false
          })
        },
           
      },
      

      
    }
  
</script>
<style scoped>
.v-data-table {
  border: 1px solid #e0e0e0;
}

.v-data-table ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table ::v-deep tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.v-btn {
  text-transform: none;
  letter-spacing: 0;
}

.v-text-field ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.v-select ::v-deep .v-input__prepend-inner {
  margin-top: 8px !important;
}

.rounded-lg {
  border-radius: 8px !important;
}

.rounded-t-lg {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

@media only screen and (max-width: 480px) {

}
</style>